angular.module('ui.shell',
    [
        'ui.home',
        'ui.order',
        'ui.help',
        'ui.user'
    ])
    .config(function ($stateProvider, customTemplateResolverProvider) {
        $stateProvider.state('client', {
            url: '/client?hidemenu',
            template: customTemplateResolverProvider.get('shell.html', 'app/ui/shell/shell.html'),
            controller: 'ClientController',

            data: {pageTitle: 'OrderManager: Tracking Client'},

            resolve: {
                translationsInitPromise: function (appLocale) {
                    return appLocale.loading.ensureLoaded();  // hold state initialization until promise will be resolved
                },
                currentUser: function (usersRepository) {
                    return usersRepository.getCurrentUser();
                }
            }
        });
    })

    .controller('ClientController', function ClientController($log, $state, $scope, $localStorage, customResourceResolver, currentUser,
                                                              serverInfoService, authService) {
        var MENU_MINIMIZED_STORAGE_NAME = "Nav-Menu-Minimized";

        $scope.user = currentUser;
        $scope.hidemenu = ($state.params.hidemenu && $state.params.hidemenu === 'true');
        $scope.minimizedMenu = false;

        $scope.submitSearch = function () {
            if ($scope.search && $scope.search != null && $scope.search !== '') {
                $state.go('client.orders',
                    {
                        step: $state.params.step ? $state.params.step : 'all-open',
                        search: $scope.search,
                        exact: false
                    });
            }
            $scope.search = null;
        };

        initController();
        
        function initController() {
            $scope.minimizedMenu = $localStorage.getItem(MENU_MINIMIZED_STORAGE_NAME);

            //Init menu state watcher and its destructor
            var minimizedMenuWatcherDestructor = $scope.$watch(
                'minimizedMenu',
                function (newVal, oldVal) {
                    if (newVal !== oldVal) {
                        //Store into localStorage
                        $localStorage.setItem(MENU_MINIMIZED_STORAGE_NAME, newVal);
                    }
                }
            );
            $scope.$on('$destroy', function () {
                minimizedMenuWatcherDestructor();
            });

            //overrides the url param according to the customization config
            customResourceResolver.resolveConfig('shell-config')
                .then(function (shellConfig) {
                    if (shellConfig) {
                        //$scope.hidemenu = shellConfig.hideMenu === true;
                        $scope.newOrderAllowed = shellConfig.newOrderAllowed;
                    }
                });

            //hack that will hide loading screen, when main state is ready
            if (window.omHideLoadingScreenCallback) {
                window.omHideLoadingScreenCallback();
            }

            authService.events.on('login', function () {
                //And check on re-login if we need to ask user to reload current tab to load latest client app version from server
                return serverInfoService.checkServerVersionAndAskReloadIfNeeded();
            });
        }

    })
;
